import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthGuard} from '@core/guards/services/auth-guard.service';
import {CloudTokenAuthGuard} from '@core/guards/services/cloud-token-auth-guard.service';
import {CoordinatorGuard} from '@core/guards/services/coordinator-guard.service';
import {CrmTokenAuthGuard} from '@core/guards/services/crm-token-auth-guard.service';
import {HomeGuard} from '@core/guards/services/home-guard.service';
import {LoginGuard} from '@core/guards/services/login-guard.service';
import {PractitionerGuard} from '@core/guards/services/practitioner-guard.service';
import {SpecialistGuard} from '@core/guards/services/specialist-guard.service';
import {ClientGuard} from '@core/guards/services/client-guard.service';
import {AdminGuard} from '@core/guards/services/admin-guard.service';

import {AccountComponent} from './account/account.component';
import {ExpertClausesComponent} from './clause/expert-clauses.component';
import {ProcessClausesComponent} from './clause/process-clauses.component';
import {ClientComponent} from './client/client.component';
import {ContactComponent} from './contact/contact.component';
import {FlowComponent} from './flow/flow.component';
import {LoginComponent} from './login/login.component';
import {RankingComponent} from './ranking/ranking.component';
import {CandidateQualificationComponent} from './interviews/candidate-qualification/candidate-qualification.component';
import {ClientInterviewComponent} from './interviews/client-interview/client-interview.component';
import {CandidateClauseComponent} from './candidate-clause/candidate-clause.component';
import {TimeTrackerComponent} from './ecv-project/time-tracker/time-tracker.component';
import {ProjectComponent} from './ecv-project/project.component';
import {AcceptClauseComponent} from './candidate-clause/accept-clause.component';
import {DeclineClauseComponent} from './candidate-clause/decline-clause.component';
import {WebSearchComponent} from './web-search/web-search.component';
import {PhoneInterviewComponent} from './interviews/phone-interview/phone-interview.component';
import {DictPanelComponent} from './dict-panel/dict-panel.component';
import {CoordinatorsComponent} from './coordinators/coordinators.component';
import {DeleteSpecialistComponent} from './delete-specialist/delete-specialist.component';

const appRoutes: Routes = [
  {path: 'login', component: LoginComponent, canActivate: [LoginGuard]},
  {path: 'crm/authorize', canActivate: [CrmTokenAuthGuard], children: []},
  {path: 'cloud/authorize', canActivate: [CloudTokenAuthGuard], children: []},
  {path: 'ecv', component: FlowComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'ecv/:step', component: FlowComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'ecv/:step/:refNumber', component: FlowComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'phone-interview', component: PhoneInterviewComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'phone-interview/:refNumber', component: PhoneInterviewComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'candidate-qualification', component: CandidateQualificationComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'candidate-qualification/:refNumber', component: CandidateQualificationComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'client-interview', component: ClientInterviewComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'client-interview/:refNumber', component: ClientInterviewComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'process-clauses', component: ProcessClausesComponent, canActivate: [AuthGuard, PractitionerGuard]},
  {path: 'user-clauses/:id', component: ExpertClausesComponent, canActivate: [AuthGuard, PractitionerGuard]},
  {path: 'delete-specialist', component: DeleteSpecialistComponent, canActivate: [AuthGuard, PractitionerGuard]},
  {path: 'ranking', component: RankingComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'ranking/:jobOrderNumber', component: RankingComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'account', component: AccountComponent, canActivate: [AuthGuard, SpecialistGuard]},
  {path: 'contact', component: ContactComponent, canActivate: [AuthGuard, SpecialistGuard]},
  {path: 'projects', component: ProjectComponent, canActivate: [AuthGuard, SpecialistGuard]},
  {path: 'client', component: ClientComponent, canActivate: [AuthGuard, ClientGuard]},
  {path: 'accept-clause/:token', component: AcceptClauseComponent},
  {path: 'decline-clause/:token', component: DeclineClauseComponent},
  {
    path: 'timetracker',
    component: TimeTrackerComponent,
    canActivate: [AuthGuard, SpecialistGuard]
  },
  {path: 'candidate-clause', component: CandidateClauseComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'web-search', component: WebSearchComponent, canActivate: [AuthGuard, CoordinatorGuard]},
  {path: 'dict-panel', component: DictPanelComponent, canActivate: [AuthGuard, AdminGuard]},
  {path: 'coordinators', component: CoordinatorsComponent, canActivate: [AuthGuard, AdminGuard]},
  {path: '**', canActivate: [HomeGuard], children: []}
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/app-routing.module.ts